import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Chrome, LogOut } from 'lucide-react';

export const AccountCard = ({ authUser, isLoggedIn, onLogout, onGoogleSignIn }) => (
  <Card className="p-5 sm:p-6 mb-8" data-testid="account-card">
    {isLoggedIn ? (
      <div className="flex flex-col sm:flex-row items-center gap-4">
        {authUser.picture ? (
          <img src={authUser.picture} alt={authUser.name} className="w-14 h-14 rounded-full" referrerPolicy="no-referrer" />
        ) : (
          <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-xl">
            {(authUser.name || authUser.email || '?')[0].toUpperCase()}
          </div>
        )}
        <div className="flex-1 text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-semibold" data-testid="user-name">{authUser.name || 'Clarity Reader'}</h2>
          <p className="text-sm text-gray-600" data-testid="user-email">{authUser.email}</p>
          <p className="text-xs text-green-600 mt-1">Signed in with Google — your preferences are saved to your profile</p>
        </div>
        <Button variant="outline" size="sm" onClick={onLogout} className="flex items-center gap-2" data-testid="logout-button">
          <LogOut className="w-4 h-4" />
          Sign Out
        </Button>
      </div>
    ) : (
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
          <Chrome className="w-7 h-7 text-gray-400" />
        </div>
        <div className="flex-1 text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-semibold">You're browsing as a guest</h2>
          <p className="text-sm text-gray-600">Sign in with Google to save your sources, score, and progress across devices.</p>
        </div>
        <Button onClick={onGoogleSignIn} className="flex items-center gap-2" data-testid="google-signin-button">
          <Chrome className="w-5 h-5" />
          Sign in with Google
        </Button>
      </div>
    )}
  </Card>
);
